import { Provider } from "react-redux";
import { createRoot } from "react-dom/client"; // Updated for React 18
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import store from "./Redux/Store/store";
import { NotificationProvider } from "./Components/CreditNotification"; // Adjust the import path as needed

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <NotificationProvider>
      <App />
    </NotificationProvider>
  </Provider>
);